export default __webpack_public_path__ + "images/24.27b6cba.png";